window.initVoltreyaScenes = () => {
  const section = document.querySelector('.rooms, .spaces');
  if (!section || !window.Splide || section.dataset.veInitialized) return;
  section.dataset.veInitialized = 'true';

  const isEvening = section.classList.contains('spaces');
  const scenes = [
    {
      key: 'living', label: 'Living Room', moment: 'Dusk / Living Room', image: 'scene-living-v2.png',
      alt: 'Dusk living room with lamps, television and a visible wall outlet',
      claim: 'Energy-Saving Support', heading: 'Support Smarter Power Use At Home.',
      detail: 'From evening lighting to the TV, Voltreya is designed to help reduce unnecessary household energy waste.',
      context: 'Evening Lights · Everyday Electricity'
    },
    {
      key: 'office', label: 'Home Office', moment: 'Late Afternoon / Home Office', image: 'scene-office-v2.png',
      alt: 'Home office with desk lamp, laptop and a clearly visible wall outlet',
      claim: 'Voltage Stability', heading: 'A Steadier Setting For Your Workday.',
      detail: 'For a workspace with a computer and lamp, Voltreya is designed to support voltage stability at a compatible outlet.',
      context: 'Computer · Task Lighting'
    },
    {
      key: 'kitchen', label: 'Kitchen', moment: 'Morning / Kitchen', image: 'scene-kitchen-v2.png',
      alt: 'Morning kitchen with coffee maker, kettle, toaster and visible wall outlet',
      claim: 'Appliance Protection', heading: 'Support The Appliances In Your Daily Routine.',
      detail: 'Voltreya is designed to help protect household appliances from over-voltage and power surges.',
      context: 'Coffee Maker · Kettle · Toaster'
    },
    {
      key: 'bedroom', label: 'Bedroom', moment: 'Night / Bedroom', image: 'scene-bedroom-v2.png',
      alt: 'Bedroom at night with reading lamp, nightstand and visible wall outlet',
      claim: 'Plug-In Simplicity', heading: 'Plug In. No Complicated Setup.',
      detail: 'Use a compatible dry indoor wall outlet. No rewiring, tools or complicated setup are needed.',
      context: 'Compatible Outlet · No Rewiring'
    },
    {
      key: 'media', label: 'Media Room', moment: 'Rainy Evening / Media Room', image: 'scene-media-v2.png',
      alt: 'Media room with television, speakers, game console and visible wall outlet',
      claim: 'Electronics Support', heading: 'Look After The Electronics You Enjoy.',
      detail: 'Voltreya is designed to support the household electrical environment and help protect everyday electronics.',
      context: 'TV · Audio · Game Console'
    }
  ];

  const esc = value => value.replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const slide = scene => {
    const picture = `<img src="${window.Voltreya.assets[scene.image]}" alt="${esc(scene.alt)}" loading="lazy" draggable="false">`;
    const device = `<a class="scene-device-card" href="${window.Voltreya.productUrl}#gallery"><img src="${window.Voltreya.assets['device-front.webp']}" alt="Original Voltreya product photograph"><span><small>THE ACTUAL DEVICE</small><strong>Plug In. No Complicated Setup.</strong><em>See Product Photos</em></span></a>`;
    const copy = `<span class="scene-label">${esc(scene.moment)}</span><p class="scene-claim">${esc(scene.claim)}</p><h3>${esc(scene.heading)}</h3><p class="scene-detail">${esc(scene.detail)}</p><span class="scene-context">${esc(scene.context)}</span><a class="scene-more" href="${window.Voltreya.productUrl}#gallery">Explore The Device</a>`;
    return `<li class="splide__slide">${isEvening
      ? `<div class="space-display"><div class="space-photo" data-scene="${scene.key}">${picture}<span class="scene-moment">${esc(scene.moment)}</span>${device}</div><div class="space-copy"><div>${copy}</div></div></div>`
      : `<div class="room-stage"><div class="room-photo" data-scene="${scene.key}">${picture}<span class="scene-moment">${esc(scene.moment)}</span>${device}</div><div class="room-info"><div>${copy}</div></div></div>`
    }</li>`;
  };

  const tabs = section.querySelector(isEvening ? '.space-tabs' : '.room-tabs');
  const stage = section.querySelector(isEvening ? '.space-display' : '.room-stage');
  if (!tabs || !stage) return;
  const carousel = document.createElement('div');
  carousel.className = 'splide scene-carousel';
  carousel.setAttribute('aria-label', 'Voltreya In Your Home');
  carousel.innerHTML = `<div class="splide__track"><ul class="splide__list">${scenes.map(slide).join('')}</ul></div>`;
  const controls = document.createElement('div');
  controls.className = 'scene-controls';
  controls.innerHTML = `<div class="scene-tabs" role="group" aria-label="Choose A Home Scene">${scenes.map((scene, index) => `<button type="button" data-scene-go="${index}" aria-pressed="${index === 0}">${esc(scene.label)}</button>`).join('')}</div><div class="scene-stepper"><span data-scene-count>01 / 05</span><button type="button" data-scene-prev aria-label="Previous Scene">‹</button><button type="button" data-scene-next aria-label="Next Scene">›</button></div>`;
  tabs.replaceWith(controls);
  stage.replaceWith(carousel);
  if (isEvening) {
    const caption = document.createElement('p');
    caption.className = 'scene-disclosure';
    caption.textContent = 'Illustrative home scenes. Product photos show the actual Voltreya device.';
    carousel.after(caption);
  }

  const slider = new Splide(carousel, {
    type: 'loop', perPage: 1, gap: 0, speed: 560, drag: true,
    arrows: false, pagination: false, autoplay: 'pause', interval: 8500,
    pauseOnHover: true, pauseOnFocus: true, keyboard: 'focused',
    reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' },
    live: false
  });
  let hasManualInput = false;
  let inView = false;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pauseForUser = () => { hasManualInput = true; slider.Components.Autoplay?.pause(); };
  const refresh = () => {
    const current = slider.index;
    controls.querySelectorAll('[data-scene-go]').forEach((button, index) => {
      button.setAttribute('aria-pressed', String(index === current));
      button.classList.toggle('is-active', index === current);
    });
    controls.querySelector('[data-scene-count]').textContent = `${String(current + 1).padStart(2, '0')} / ${String(scenes.length).padStart(2, '0')}`;
  };
  slider.on('mounted moved', refresh);
  slider.mount();
  controls.querySelectorAll('[data-scene-go]').forEach(button => button.addEventListener('click', () => { pauseForUser(); slider.go(Number(button.dataset.sceneGo)); }));
  controls.querySelector('[data-scene-prev]').addEventListener('click', () => { pauseForUser(); slider.go('<'); });
  controls.querySelector('[data-scene-next]').addEventListener('click', () => { pauseForUser(); slider.go('>'); });
  carousel.querySelector('.splide__track').addEventListener('pointerdown', pauseForUser, { passive: true });
  carousel.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') pauseForUser(); });
  const updateAutoplay = () => {
    if (inView && !hasManualInput && !document.hidden && !reduceMotion.matches) slider.Components.Autoplay.play();
    else slider.Components.Autoplay.pause();
  };
  const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; updateAutoplay(); }, { threshold: 0.45 });
  observer.observe(carousel);
  document.addEventListener('visibilitychange', updateAutoplay);
  reduceMotion.addEventListener?.('change', updateAutoplay);
};
window.initVoltreyaScenes();
document.addEventListener('shopify:section:load', () => window.initVoltreyaScenes());